<template>
	<div
		v-if="!orderCheckout.isOrderLocked"
		ref="containerRef"
		class="order-steps w-full overflow-x-auto scroll-smooth"
	>
		<ul class="flex w-max gap-1">
			<li
				v-for="step in orderSteps"
				:key="step"
				:ref="(el) => setStepRef(el, step)"
			>
				<CarbarLink
					hover-color=""
					:to="
						isDisabled(step) || isReopenable(step)
							? undefined
							: step
					"
					:external="false"
					@click="onStepClick(step)"
				>
					<OrderStepButton
						:is-active="isActive(step)"
						:is-past="isPast(step)"
					>
						{{ step }}
					</OrderStepButton>
				</CarbarLink>
			</li>
		</ul>
	</div>
</template>

<script setup lang="ts">
import OrderStepButton from '@/components/buttons/OrderStepButton.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import { useOrderCheckout } from '@/stores/order-checkout'
import type { OrderStep } from '@/utils/order-checkout'

const route = useRoute()
const orderCheckout = useOrderCheckout()
const containerRef = ref<HTMLElement | null>(null)
const stepRefs = ref<Record<string, HTMLElement>>({})

const { isPast, isActive, isDisabled, isReopenable } = useCheckoutSummary()

// A confirmed order has to reopen before its earlier steps can open
const onStepClick = (step: OrderStep) => {
	if (!isDisabled(step) && isReopenable(step)) {
		orderCheckout.returnToStep(step)
	}
}

// Helper to store DOM elements by step key
const setStepRef = (el: ComponentPublicInstance, step: string) => {
	if (el) {
		stepRefs.value[step] = el.$el || el
	}
}

// Watch route changes and center the active step button
watch(
	() => route.path,
	async () => {
		await nextTick()
		const activeStep = orderSteps.find((step) => route.path.includes(step))

		if (activeStep && stepRefs.value[activeStep]) {
			stepRefs.value[activeStep].scrollIntoView({
				behavior: 'smooth',
				block: 'nearest',
				inline: 'center', // Centers the step horizontally inside the scroll container
			})
		}
	},
	{ immediate: true }
)
</script>
